import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ModuleSection } from './components/ModuleSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
type AppProps = {
  /** Shows the rotating social-proof toast near the bottom of the page. */
  showPurchaseToast?: boolean;
};
export function App({
  showPurchaseToast = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-ink font-sans" data-id="element-0" data-mp="3ijpef4c7z5bc">
      <Hero data-id="element-1" data-mp="3mkrgdsxitvh0" />
      <main data-id="element-2" data-mp="3mk868ye44bdj">
        <ProblemSection data-id="element-3" data-mp="3mjzpuwis6nxl" />
        <TomosSection data-id="element-4" data-mp="3mj6k9yvk64h1" />
        <BonosSection data-id="element-5" data-mp="3rbr9en3irte8" />
        <PricingSection data-id="element-6" data-mp="3rdaselgk8ijp" />
        <ModuleSection data-id="element-7" data-mp="3rd1all5o5hp3" />
        <TestimonialsSection data-id="element-8" data-mp="3relwynhtxubv" />
        <GuaranteeSection data-id="element-9" data-mp="67z9oh5w26u" />
        <FaqSection data-id="element-10" data-mp="4n7u7q58zd7" />
        <CostSection data-id="element-11" data-mp="82kz509bybz" />
        <FinalCta data-id="element-12" data-mp="2zl3c5m4yv85u" />
      </main>
      <Footer data-id="element-13" data-mp="2zlv32jnmchps" />
      {showPurchaseToast ? <PurchaseToast data-id="element-14" data-mp="2zmwh8wzxlkbq" /> : null}
    </div>;
}